
  <!-- <dashboardnav>
  </dashboardnav> -->
   <!-- <pre>{{impactedassets$ | async | json}}</pre> -->
   <div class="box green_box"></div>
   <div class="box pink_box"></div>
    <main class="incidence_main" [@fadeInAnimation]>

<cradua-incidentsearch
[task] = "task"
(emitTask)="onTask($event)"
(searchEmit)="onSearch($event)"
(emitIncidentType)="onHandleIncidentType($event)"
>
</cradua-incidentsearch>
<mrsoftapps-epims-reference-spinner
*ngIf="(isLoadingIncident$ | async)">

</mrsoftapps-epims-reference-spinner>
<div [ngSwitch]="task">
  <ng-template ngSwitchCase="list">
      <cradua-incident-list
      [incident]="incident$ | async"
      [uoms]="uoms$ | async"
      (dispatchView)="onEmitView($event)"
      (dispatchDelete)="onEmitDelete($event)"
      (searchEmit)="onSearchRange($event)"
      *ngIf="!(isLoadingIncident$ | async)"

      >
      </cradua-incident-list>
      <mrsoftapps-epims-reference-spinner
      *ngIf="(isLoadingIncident$ | async)">

      </mrsoftapps-epims-reference-spinner>
  </ng-template>

  <ng-template ngSwitchCase="create">
 <cradua-incident
    [ownershiptypes] = "ownershiptypes$ | async"
    [landTitles]="landTitle$ | async"
    [incidentcategorys]="incidentcategorys$ | async"
    [incidentsubcategorys]="incidentsubcategorys$ | async"
    [quantums]="quantums$ | async"
    [facilityassets]="facilityassets$ | async"
    [cleanupstatuss] = "cleanupstatuss$ | async"
    [uoms] = "uoms$ | async"
    [partys] = "partys$ | async"
    [terrains] = "terrains$ | async"
    [states] = "states$ | async"
    [lgas] = "lgas$ | async"
    [appConfig] = "appConfig$ | async"
    [banks] = "banks$ | async"
    [titles] = "titles$ | async"
    [communities]="communities$ | async"
    [incident]="incident$ | async"
    [areaofimpacts]="areaofimpacts$ | async"
    [impactedassets]="impactedassets$ | async"

    [fetchDocuments]="fetchDocument$ | async"
    [securityClassifications]="securityClassification$ | async"
    [documentTypeCodes]="documentTypeCode$ | async"
    [documentTypes]="documentType$ | async"
    [fileLocations]="fileLocation$ | async"
    [isLoadingDocument]="isLoadingDocument$ | async"
    [completed]="completed$ | async"
    [progress]="progress$ | async"
    [error]="error$ | async"
    [isInProgress]="isInProgress$ | async"
    [isReady]="isReady$ | async"
    [hasFailed]="hasFailed$ | async"
    (emitUpload)="uploadFile($event)"
    (emitSaveManyDoc)="onSaveManyDoc($event)"
    (emitCancel)="cancelUpload($event)"
    (emitReset)="resetUpload($event)"

    (emitIncident)="onSaveIncident($event)"
    [addressBooks]="addressBook$ | async"
    [isLoadingAddressBook]="isLoadingAddressBook$ | async"

    (emitAddressBook)="onSearchAddressBook($event)"
    (emitSaveAddressBook)="onSaveAddressBook($event)"

    (emitClearAddressBook)="onEmitClearAddressBook($event)"
    (emitAssetDelete)="onAssetDelete($event)"
    *ngIf="
    !(isLoadingIncident$ | async ) &&
    !(isLoadingFileLocation$ | async) &&
    !(isLoadingDocumentType$ | async) &&
    !(isLoadingDocumentTypeCode$ | async) &&
    !(isLoadingSecurityClassification$ | async)
    "
 >
  </cradua-incident>
  <!-- (emitSaveAddressBookLessor)="onSaveAddressBookLessor($event)" -->
    <!-- <mrsoftapps-epims-reference-spinner
    *ngIf="
    !(isLoadingIncident$ | async )
    "
  >
    </mrsoftapps-epims-reference-spinner> -->
  </ng-template>
</div>
</main>
